class Menu {
  constructor() {
    this.menu = null;
    this.subMenuStack = [];
    this.initMenu();
  }

  initMenu() {
    this.menu = this.querySelectorSafe(".noahs-menu.noahs-menu--responsive");
    this.menuWrapper = this.querySelectorSafe(".noahs-menu--wrapper");
    this.menuArrow = this.menu ? this.querySelectorSafe(".menu__arrow", this.menu) : null;
    this.menuTitle = this.menu ? this.querySelectorSafe(".menu__title", this.menu) : null;
    this.burger = this.querySelectorSafe(".burger");
    this.overlay = this.querySelectorSafe(".overlay");

    if (this.burger) this.burger.addEventListener("click", () => this.toggleMenu());
    if (this.overlay) this.overlay.addEventListener("click", () => this.toggleMenu());
    if (this.menuArrow) this.menuArrow.addEventListener("click", () => this.hideSubMenu());

    if (this.menu) {
      this.menu.addEventListener("click", (e) => this.onMenuClick(e));
      this.menu.addEventListener("keydown", (e) => this.onMenuKeyDown(e));
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 768 && this.menu && this.menu.classList.contains("is-active")) {
        this.toggleMenu();
      }
    });
  }

  querySelectorSafe(selector, parent = document) {
    const el = parent.querySelector(selector);
    return el ? el : null;
  }

  // helper robusto para encontrar el <li> que contiene el dropdown
  findDropdownLi(el) {
    if (!el) return null;
    // intenta el selector que **solo** coincide con <li>
    let li = el.closest('li.menu__dropdown');
    if (li) return li;
    // fallback: si closest devuelve otro elemento con esa clase (ej: <a class="menu__dropdown">),
    // subimos hasta el LI que tenga .menu__dropdown
    const any = el.closest('.menu__dropdown');
    if (any) {
      const upLi = any.closest('li.menu__dropdown');
      if (upLi) return upLi;
      // último recurso: buscar el ancestor li
      const ancestorLi = any.closest('li');
      if (ancestorLi && ancestorLi.classList.contains('menu__dropdown')) return ancestorLi;
    }
    return null;
  }

  toggleMenu() {
    if (!this.menu) return;
    const wasOpen = this.menu.classList.contains("is-active");
    this.menu.classList.toggle("is-active");
    if (this.overlay) this.overlay.classList.toggle("is-active");
    if (this.menuWrapper) this.menuWrapper.classList.toggle("is-active");
    if (wasOpen) this.closeAllSubmenus();
  }

  onMenuClick(e) {
    // 1) click en el icono (dentro del <a>)
    const icon = e.target.closest(".fa-chevron-right, i.fa-chevron-right");
    if (icon) {
      e.preventDefault();
      e.stopPropagation();
      const parentDropdown = this.findDropdownLi(icon);
      if (parentDropdown) {
        this.showSubMenu(parentDropdown);
      }
      return;
    }

    // 2) click en <a> sin href (nolink) -> abrir submenu
    const anchor = e.target.closest("a.menu__link, a");
    if (anchor) {
      const href = anchor.getAttribute("href");
      const parentDropdown = this.findDropdownLi(anchor);
      if (parentDropdown && (!href || href === "#" || href.trim() === "")) {
        e.preventDefault();
        this.showSubMenu(parentDropdown);
        return;
      }
      // si tiene href real, dejamos que navegue
    }
  }

  onMenuKeyDown(e) {
    if (e.key === "Enter" || e.key === " ") {
      const icon = e.target.closest(".fa-chevron-right, i.fa-chevron-right");
      if (icon) {
        e.preventDefault();
        const parentDropdown = this.findDropdownLi(icon);
        if (parentDropdown) this.showSubMenu(parentDropdown);
        return;
      }

      const anchor = e.target.closest("a.menu__link, a");
      if (anchor) {
        const href = anchor.getAttribute("href");
        const parentDropdown = this.findDropdownLi(anchor);
        if (parentDropdown && (!href || href === "#" || href.trim() === "")) {
          e.preventDefault();
          this.showSubMenu(parentDropdown);
        }
      }
    }
  }

  showSubMenu(parent) {
    if (!parent) return;

    // buscar submenu hijo directo
    let subMenu = null;
    try {
      subMenu = parent.querySelector(":scope > .submenu");
    } catch (err) {
      subMenu = Array.from(parent.children).find((c) => c.classList && c.classList.contains("submenu")) || null;
    }
    if (!subMenu) return;

    const last = this.subMenuStack.length ? this.subMenuStack[this.subMenuStack.length - 1] : null;
    if (last && last.subMenu === subMenu) return;

    // cerrar submenus que no sean ancestros del nuevo parent
    while (this.subMenuStack.length) {
      const top = this.subMenuStack[this.subMenuStack.length - 1];
      if (top.parent.contains(parent) || top.parent === parent || parent.contains(top.parent)) break;
      const popped = this.subMenuStack.pop();
      popped.subMenu.classList.remove("is-active");
      if (popped.anchor && popped.anchor.tagName && popped.anchor.tagName.toLowerCase() === "a") {
        popped.anchor.setAttribute("aria-expanded", "false");
      }
      popped.subMenu.style.animation = "";
    }

    subMenu.classList.add("is-active");
    subMenu.style.animation = "slideLeft 0.35s ease forwards";

    const anchor = parent.querySelector("a.menu__link, a, span");
    if (anchor && anchor.tagName && anchor.tagName.toLowerCase() === "a") {
      anchor.setAttribute("aria-expanded", "true");
    }

    const menuTitleText = anchor ? anchor.textContent.trim() : "";
    if (this.menuTitle) this.menuTitle.textContent = menuTitleText;
    if (this.menu && this.menu.querySelector(".menu__header")) {
      this.menu.querySelector(".menu__header").classList.add("is-active");
    }

    this.subMenuStack.push({ subMenu, parent, anchor });
  }

  hideSubMenu() {
    if (!this.subMenuStack.length) {
      if (this.menuTitle) this.menuTitle.textContent = "";
      if (this.menu && this.menu.querySelector(".menu__header")) {
        this.menu.querySelector(".menu__header").classList.remove("is-active");
      }
      return;
    }

    const { subMenu, parent, anchor } = this.subMenuStack.pop();

    subMenu.style.animation = "slideRight 0.35s ease forwards";
    setTimeout(() => {
      subMenu.classList.remove("is-active");
    }, 300);

    if (anchor && anchor.tagName && anchor.tagName.toLowerCase() === "a") {
      anchor.setAttribute("aria-expanded", "false");
    }

    const prev = this.subMenuStack.length ? this.subMenuStack[this.subMenuStack.length - 1] : null;
    if (prev) {
      const prevAnchor = prev.anchor;
      if (this.menuTitle) this.menuTitle.textContent = prevAnchor ? prevAnchor.textContent.trim() : "";
    } else {
      if (this.menuTitle) this.menuTitle.textContent = "";
      if (this.menu && this.menu.querySelector(".menu__header")) {
        this.menu.querySelector(".menu__header").classList.remove("is-active");
      }
    }
  }

  closeAllSubmenus() {
    while (this.subMenuStack.length) {
      const { subMenu, anchor } = this.subMenuStack.pop();
      subMenu.classList.remove("is-active");
      if (anchor && anchor.tagName && anchor.tagName.toLowerCase() === "a") anchor.setAttribute("aria-expanded", "false");
      subMenu.style.animation = "";
    }
    if (this.menuTitle) this.menuTitle.textContent = "";
    if (this.menu && this.menu.querySelector(".menu__header")) this.menu.querySelector(".menu__header").classList.remove("is-active");
  } 
}

export default Menu;
